import type { Job, JobStatus } from "@facade/contracts";
import { jobsApi } from "@facade/services";
import { queryOptions } from "@tanstack/react-query";

export const activeJobStatuses = new Set<JobStatus>([
  "ACCEPTED",
  "DISPATCHING",
  "QUEUED",
  "STARTING",
  "RUNNING",
]);

export const isJobActive = (job: Pick<Job, "status">) =>
  activeJobStatuses.has(job.status);

export const jobQueryKeys = {
  all: ["jobs"] as const,
  list: () => [...jobQueryKeys.all, "list"] as const,
  detail: (jobId: string) => [...jobQueryKeys.all, "detail", jobId] as const,
};

export const jobQueries = {
  list: () =>
    queryOptions({
      queryKey: jobQueryKeys.list(),
      queryFn: () => jobsApi.getAll(),
      refetchInterval: (query) =>
        query.state.data?.some(isJobActive) ? 2_000 : 60_000,
      refetchOnWindowFocus: true,
    }),
  detail: (jobId: string) =>
    queryOptions({
      queryKey: jobQueryKeys.detail(jobId),
      queryFn: () => jobsApi.getById(jobId),
      refetchInterval: (query) =>
        query.state.data && isJobActive(query.state.data) ? 2_000 : false,
    }),
};
